// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type GRMiscState } from '../reducers/gr';
import { type GRNotificationState } from '../types/notification';

const emtpyObj = {};
const emptyArray: [] = [];

export const selectGRMiscState = createSelector(
  (state: StateType): GRMiscState => state.gr.misc,
  (misc) => misc ?? emtpyObj,
);

export const selectGRMiscTmpNotifications = createSelector(
  selectGRMiscState,
  (misc): Array<GRNotificationState> => misc.tmpNotifications ?? emptyArray,
);

export const selectGRMiscHomeVisitedIndex = createSelector(selectGRMiscState, (misc) => misc.homeVisitedIndex);

export const selectGRMiscCurrentNotification = createSelector(
  [selectGRMiscTmpNotifications],
  (notifications) => notifications?.[0],
);
